<template>
  <div class="cialdetzw">
    <div class="zwtop">
      <div class="zwtopl">
        <div class="zwtopxt1">{{ lawinfo.title }}</div>
        <div class="zwtopxt2">更新时间：{{ lawinfo.updated_at }}</div>
        <img :src="lawinfo.preview_pic" />
        <div class="zwtopxt3" v-html="lawinfo.content"></div>
      </div>
    </div>
    <articaside v-show="ishide" :style="{ bottom: asidebom }" />
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
import articaside from "views/fgartic/components/articaside";
export default {
  props:['lawinfo'],
  components: {
    subTitle,
    articaside,
  },
  data: () => ({
    ishide: false,
    asidebom: "0",
    hidetop: 1200,
  }),
  mounted() {
    // 监听滚动事件
    this.$nextTick(() => {
      this.handleScroll();
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let bomjl = window.pageYOffset + window.innerHeight; //获取x点坐标加上窗口左边，得到底部滚动距离
      let bomofftop = document.querySelector(".footer").offsetTop; //获取footer的offsetTop值
      this.ishide = bomjl > this.hidetop + 400; //有目录是650
      if (bomjl > bomofftop) {
        this.asidebom = bomjl - bomofftop + 50 + "px";
      } else {
        this.asidebom = "40px";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cialdetzw {
  min-height: 850px;
  width: 100%;
  background: #ffffff;
  .zwtop {
    padding: 30px 28px 0;
    .zwtopl {
      color: #333333;
      .zwtopxt1 {
        font-size: 34px;
      }
      .zwtopxt2 {
        margin-top: 16px;
        font-size: 12px;
      }
      .zwtopxt3 {
        margin-top: 20px;
        text-indent: 2em;
        font-size: 14px;
        line-height: 26px;
      }
      img {
        width: 254px;
        height: 254px;
        float: right;
      }
    }
  }
}
</style>